import IncompletePaymentsModal from "features/IncompletePaymentsModal";
import ReacceptTermsModal from "features/ReacceptTermsModal";
import useActivePaymentsHandler from "hooks/useActivePaymentsHandler";
import useAuthState from "hooks/useAuthState";
import useContactTerms from "hooks/useContactTerms";
import useCookie from "hooks/useCookie";
import useDidUpdate from "hooks/useDidUpdate";
import useSystemState from "hooks/useSystemState";
import { isUndefined } from "lodash";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  retrieveContact,
  retrieveContactPaymentType,
  retrieveContactPaymentWarning,
} from "store/features/contact.store";
import { fetchContactRequest } from "store/requests/contact.requests";

const AuthenticatedRoute = () => {
  useActivePaymentsHandler();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [, , removeCookie] = useCookie();

  const shouldShowIncompletePaymentsWarning = useSelector(retrieveContactPaymentWarning);
  const contact = useSelector(retrieveContact);
  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  const { isAuthenticated, user, loading } = useAuthState();
  const { isSystemLoading, isSystemLoadingFailed } = useSystemState();

  const shouldReacceptTerms = useContactTerms();

  const isTesting = useMemo(() => !isUndefined(window.Cypress), []);

  useEffect(() => {
    if (user || loading) return;

    navigate("/login");
  }, [user, loading, navigate]);

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) return;
    removeCookie("drawerPosition");
  }, [isAuthenticated, removeCookie, loading]);

  useDidUpdate(
    (prev, curr) => {
      if (!isCheckoutPaymentType) return;
      if (prev.location === curr.location) return;
      if (prev.location !== "/new-order" && prev.location !== "/") return;

      dispatch(fetchContactRequest({ contactId: contact.contact_id, backgroundLoad: true }));
    },
    { location: location.pathname, contact, isCheckoutPaymentType }
  );

  if (isSystemLoading || isSystemLoadingFailed) return null;
  if (isAuthenticated || !!isTesting) {
    return (
      <>
        <Outlet />

        {shouldReacceptTerms && <ReacceptTermsModal />}

        {!shouldReacceptTerms && !!shouldShowIncompletePaymentsWarning && <IncompletePaymentsModal />}
      </>
    );
  }
  return <Navigate to="/login" />;
};

export default AuthenticatedRoute;
